<template>

	<div
		:class="[
			'header',
			{ 'dark': $parent.isWhiteBackgroundSet }
		]"
		id="header"
	>

		<div class="logo">
			<a :href="$parent.tvPlatform ? '/' : $parent.websiteUrl" >
				<img src="../assets/images/logo.svg"></a>
		</div>

		<div class="navigation-links">
			<span class="navigation-link"  @click="logout" v-if="$store.getters.getToken">
				<img :src="getIconPath()" alt="logout"></span>
			<!-- <a class="navigation-link nav-button animated-button" v-if="$store.getters.getToken === false && $parent.tvPlatform" @click="exitApp">Close</a> -->
			<a class="navigation-link  login"  :href="'/login'" v-if="!$store.getters.getToken && $route.name !== 'login' && $route.name !== 'forgotten-password'">{{ $t('register_page_form_login_link') }}</a>
			<a class="navigation-link  login"  :href="'/register'" v-if="!$store.getters.getToken && $route.name === 'login'">{{ $t('register_page_form_submit') }}</a>
			<a class="navigation-link  login"  :href="'/login'" v-if="$route.name === 'forgotten-password'">{{ $t('forgotten_password_back_to_login') }}</a>
			<!-- v-if="($route.name === 'swisscom') || ($route.name === 'register')" -->
		</div>
	</div>
</template>
<script>
import lightLogout from '../assets/images/light-logout.svg?url';
import darkLogout from '../assets/images/logout.svg?url';
	export default {
		methods: {
			getIconPath() {
				return this.$route.name === 'profile' ? lightLogout : darkLogout
			},
			// Open / Close Mobile menu
			toggleMenu: function() {
				document.getElementById('burger').classList.toggle("active");
				document.getElementById('mobile-menu').classList.toggle("active");
			},

			// Close Mobile Menu
            // closeMenu: function() {
            //     document.getElementById('burger').classList.remove("active");
            //     document.getElementById('mobile-menu').classList.remove("active");
            // },
            clearLocalStorage:function (){
                localStorage.removeItem('coupon');
                localStorage.removeItem('couponDurationCode');
            },

			// logout from account
			logout: function() {
				localStorage.removeItem('storeId')
				this.$store.dispatch('logout');
                this.clearLocalStorage();
				this.$store.dispatch('removeCurrentSelectedPlan');
				this.$store.commit('setDuration', '');
				this.$store.commit('setCoupon', '');
				localStorage.removeItem('discountDetails');
				this.$store.commit('setHasDiscountDetails', false);
				this.$router.push({name:'login'}).catch(()=>{});

				// if (window.innerWidth <= 768) {
				// 	this.closeMenu();
				// }
			},

			// Navigato to given page and close the mobile menu
			navigateTo: function(routeName) {
				// this.closeMenu();
				this.$router.push({name: routeName}).catch(()=>{});
			},

			// Exit App function used from vewd platform
			exitApp: function() {
				window.close();
			}
		},
	}
</script>
